import { Csat } from '@/components/CSAT'
import Navigation from '@/components/Navigation'
import Profile from '@/components/Profile'
import TopBanner from '@/components/TopBanner/index'
import TestModeBanner from '@/components/TopBanner/test-mode-banner'
import useConfig from '@/hooks/use-config'
import useWhatsNew from '@/hooks/use-whatsnew'
import Layout, { LayoutType } from '@/layoutDS/layout'
import { useNavigate } from '@/lib/router-dom'
import NewFeatures from "@/pages/newfeatures/new-features.jsx"
import { logout } from '@/redux/actions/auth.js'
import { retrieveDataExpiry } from '@/redux/actions/dataExpiry'
import "@/translations/i18n"
import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Tnc from '../components/Tnc/index'
import staticDataAction from '../redux/actions/static-data'
import { featureConstant } from '@/constants/configuration/feature'
import { useFeature } from '@/hooks/use-feature/index'

const DefaultLayout = ({ children }) => {

	const { goTo } = useNavigate();
	const dispatch = useDispatch()
	const user = useSelector(state => state.auth.user);
	const { data, initialized } = useSelector(state => state.staticData)
	const { storeDays, receiveDays } = useSelector(state => state.dataExpiry)

	const [tncStatus, setTncStatus] = useState(JSON.parse(sessionStorage.getItem('profile'))?.tncStatus)
	const [profile, setProfile] = useState(JSON.parse(sessionStorage.getItem('profile')))
	const [showWhatsNew, setShowWhatsNew] = useState(false);
	const isMasterDataUploadEnabled = useFeature(featureConstant.MASTER_DATA_UPLOAD);
	const [featureWhatsNew, setFeatureWhatsNew] = useState([]);

	/*=================================================
		API
	/================================================*/

	const { config, fetch: fetchConfig } = useConfig()

	useEffect(() => {

		if (profile?.tncStatus) {
			fetchConfig()
			if (initialized === false)
				dispatch(staticDataAction.setStaticData())
		}

	}, [profile])



	const mode = {
		NO_SANDBOX: !!config?.otherUrl === false,
		SANDBOX: config?.isSandbox,
		PRODUCTION: !config?.isSandbox
	}


	/*=================================================
		Filter Popup
	/================================================*/

	const [filterVisible, setFilterVisible] = useState()
	const buttonRef = useRef(null)
	const referenceRef = useRef(null)

	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick)
		return () => {
			document.removeEventListener('mousedown', handleDocumentClick)
		}
	}, [])

	function handleDocumentClick(event) {

		if (!referenceRef.current) {
			return
		}

		if (referenceRef.current.contains(event.target)) {
			return
		}
		setFilterVisible(false)
	}

	const [banners, setBanners] = useState(() => {
		let arr = []

		if (mode.SANDBOX) {
			arr.push(TestModeBanner)
		}

		if (sessionStorage.getItem('banner')) {
			//arr = [VersionBanner, ...arr]
		}

		return arr;
	})

	function removeBanner(index) {
		return () => {
			sessionStorage.removeItem('banner')
			setBanners(_banners => _banners.filter((_, idx) => idx !== index))
		}
	}

	/*=================================================
		Profile Dropdown
	/================================================*/
	const [isActive, setIsActive] = useState(false)

	const options = [
		"Account Settings",
		"Logout"
	]

	const handleSelected = (option) =>{
		if(option === 'Logout') {
			dispatch(logout(goTo))
		}
		if(option ==='Account Settings') goTo("/setting")
	}

	/*=================================================
		Features
	/================================================*/
	const { fetch, visible: whatsNewVisible } = useWhatsNew();

	function checkTnc(tncStatus){
		if (tncStatus === false) {
			setShowWhatsNew(false);
			return;
		}
	}

	async function checkWhatsNew(whatsNewValue, userInfo){
		//first time user is seeing this feature
		if (whatsNewValue === null) {
			setShowWhatsNew(true);
			return;
		}

		const [error, newFeatures] = await fetch();

		if (newFeatures.id !== userInfo?.whatsNewId) {
			setShowWhatsNew(true);
		}
		setFeatureWhatsNew(newFeatures.features);
	}

	function checkDataSetting(){
		if (storeDays === null || receiveDays === null){
			dispatch(retrieveDataExpiry())
		}
	}

	async function fetchPreLoginFunc() {
		const profileAsObj = profile;
		const tncStatus = profileAsObj?.tncStatus;
		const userInfo = JSON.parse(sessionStorage.getItem("user"));
		const whatsNewValue = userInfo?.whatsNewId;

		checkTnc(tncStatus);
		await checkWhatsNew(whatsNewValue, userInfo);
		checkDataSetting();
	}

	useEffect(() => {
		if(profile?.tncStatus === true) {
			fetchPreLoginFunc()
		}
	}, [profile]);

	const handleWhatsNew = () => {
		setShowWhatsNew(true);
	};

	return (
		<Layout type={LayoutType.Default}>
			<Layout.SideNav>
				<Navigation />
			</Layout.SideNav>
			<Layout.Header>
				<div className="layout-default__right__top">
					<div className="top-header">
						<div className="top-header__left">
							<div id="bread"></div>
						</div>
						<div className="top-header__right">
							{
								(whatsNewVisible || isMasterDataUploadEnabled) &&
								<div className="top-header__right__notification notification-icon--flex">
									<div className="notification-icon notification-icon--flex " style={{ display: "flex" }}>
										<p
											onClick={handleWhatsNew}
											className="notifiction_whats_new"
										>
											What's new
										</p>
									</div>
								</div>
							}
							<div className="top-header__right__notification notification-icon--flex">
								{/* <IconNotification /> */}
							</div>
							<div className="top-header__right__profile">
								<Profile image={user?.image} label={user?.isAdmin=== true ? "SGTraDex" : user?.orgName} options={options} isActive ={isActive} setIsActive={setIsActive} handleSelected = {handleSelected}/>
							</div>
						</div>
					</div>
				</div>
				<div>
					<TopBanner banners={banners} removeBanner={removeBanner} />
				</div>
			</Layout.Header>
			<Layout.Main>
				{tncStatus === true && children}
				{tncStatus === false && (
					<Tnc tncStatus={tncStatus} setTncStatus={setTncStatus} profile={profile} setProfile={setProfile}/>
				)}
				{
					(whatsNewVisible || isMasterDataUploadEnabled) &&
					<NewFeatures
						showWhatsNew={showWhatsNew}
						setShowWhatsNew={setShowWhatsNew}
						featureWhatsNew={featureWhatsNew}
						setFeatureWhatsNew={setFeatureWhatsNew}
						isMasterDataUploadEnabled={isMasterDataUploadEnabled}
					/>
				}
				<Csat userId={user?.id} email={user?.email} />
			</Layout.Main>
		</Layout>
	)
}

const LoginLayout = ({ children }) => {
	return (
		<>
			{children}
			<Csat />
		</>
	)
}

const Container = ({ layout, children }) => {
	switch (layout) {
		case LayoutType.Default:
			return <DefaultLayout>{children}</DefaultLayout>;
		case LayoutType.Login:
			return <LoginLayout>{children}</LoginLayout>;
		default:
			return <DefaultLayout>{children}</DefaultLayout>;
	}
};

DefaultLayout.propTypes = {
	children: PropTypes.node.isRequired,
  };

LoginLayout.propTypes = {
	children: PropTypes.node.isRequired,
};

Container.propTypes = {
	layout: PropTypes.oneOf([LayoutType.Default, LayoutType.Login]).isRequired,
	children: PropTypes.node.isRequired,
};

export default Container;
